import React, { useEffect } from "react";
import styles from "./GuestEventOverview.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { SubmitButton, TextComponent } from "../../../components";
import image from "../../../assets/live.png";
import {
  CalendarIcon,
  ClockIcon,
  LocIcon,
  UserIcon,
} from "../../../components/icons/Icons";
import { GuestMiddleware } from "../../../Store/Middlewares/GuestMiddleware";

const GuestEventOverview = () => {
  const eventData = useSelector((state) => state?.GuestReducer?.EventDetails);
  const event = useLocation().state?.eventData;
  console.log("stateee", eventData);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GuestMiddleware.getGuestEventDetails(event?.id));
  }, []);

  return (
    <div className={styles.mainCon}>
      <div className={styles.header}>
        <div className={styles.image}>
          <img src={eventData?.image} alt="eventImage" />
          {/* <img src={eventData.image} alt="eventImage" /> */}
        </div>
        <div className={styles.imgContent}>
          <TextComponent
            text={eventData?.category?.name}
            textClass={styles.categoryName}
          />
          <TextComponent text={eventData?.name} textClass={styles.name} />
          <TextComponent
            text={`${eventData?.description}`}
            textClass={styles.description}
          />
        </div>
      </div>
      <div className={styles.details}>
        <div className={styles.WedDetails}>
          <TextComponent text={"Wedding Details"} textClass={styles.name} />
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <LocIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Location:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent text={eventData?.address} />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <CalendarIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Date:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(eventData?.date).format("MMM DD, YYYY")}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <UserIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Guests:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={`${eventData?.no_of_attendee}/${eventData?.no_of_guest}`}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <ClockIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Start Time"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(eventData?.start_time).format("hh:mm a")}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <ClockIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"End Time"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(eventData?.end_time).format("hh:mm a")}
              />
            </div>
          </div>
        </div>
        <div className={styles.RecDetails}>
          <TextComponent text={"Reception Details"} textClass={styles.name} />
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <LocIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Location:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent text={eventData?.reception_address} />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <CalendarIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Date:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(eventData?.date).format("MMM DD, YYYY")}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <UserIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Guests:"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={`${eventData?.no_of_attendee}/${eventData?.no_of_guest}`}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <ClockIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"Start Time"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(eventData?.reception_start_time).format("hh:mm a")}
              />
            </div>
          </div>
          <div className={styles.subDetails}>
            <div className={styles.subLeft}>
              <ClockIcon size={20} className={styles.locationIcon} />
              <TextComponent text={"End Time"} />
            </div>
            <div className={styles.subright}>
              <TextComponent
                text={moment(eventData?.reception_end_time).format("hh:mm a")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={styles.btnsDiv}>
        <div className={styles.btns}>
          {!eventData?.is_rsvp_submitted && (
            <SubmitButton
              btnClass={styles.btn}
              title={"RSVP"}
              onClick={(e) => {
                // e.stopPropagation();
                // dispatch(GuestMiddleware.guestRsvpDetails(eventData?.id))
                //   .then(() => {
                navigate(
                  "/RsvpCelebrate",
                  {
                    state: { headrTitle: "RSVP" },
                  }
                  // eventData?.is_accepted_invitation
                  //   ? "/rsvp/rsvpGuestJoinLive"
                  //   : "/rsvp/rsvpIntro"
                );
                // })
                // .catch((err) => {
                //   console.log(err);
                // });
              }}
            />
          )}
          <SubmitButton
            btnClass={styles.btn}
            title={"Gallery"}
            onClick={(e) => {
              e.stopPropagation();
              navigate("/events/gallery", {
                state: { headrTitle: "Gallery", eventData: eventData },
              });
            }}
          />
          {eventData?.is_wedding_website && (
            <SubmitButton
              btnClass={styles.btn}
              title={"Wedding Website"}
              onClick={(e) => {
                e.stopPropagation();
                navigate("/guestWeddingWebsite", {
                  state: {
                    headrTitle: "Wedding Website",
                    eventData: eventData,
                  },
                });
              }}
            />
          )}

          <SubmitButton
            btnClass={styles.btn}
            title={"Wedding Wall"}
            onClick={(e) => {
              e.stopPropagation();
              navigate("/weddingWallGuest", {
                state: { headrTitle: "Wedding Wall", eventData: eventData },
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default GuestEventOverview;
